import { wrapCall, callGet, callPut } from './helpers'

//* ~~~~~~ EXTERNAL ROUTES ~~~~~~

// Get external channels
export const getExternalChannels = async () => {
  return await wrapCall({ method: callGet, uri: '/externals' })
}

// Update external channel
export const putExternalChannel = async (id, data) => {
  return await wrapCall({ method: callPut, uri: `/externals/${id}`, data })
}
